import React, { memo } from 'react';
import { ProgressErrorIcon, ProgressSuccessIcon } from '@aelf-design/icons';
import { useResponsive } from 'antd-style';
import Progress from "../Progress";
import useStyles from "./style";
var StepItemIcon = function StepItemIcon(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'normal' : _ref$status,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$percent = _ref.percent,
    percent = _ref$percent === void 0 ? 0 : _ref$percent,
    _ref$successIcon = _ref.successIcon,
    successIcon = _ref$successIcon === void 0 ? null : _ref$successIcon,
    _ref$errorIcon = _ref.errorIcon,
    errorIcon = _ref$errorIcon === void 0 ? null : _ref$errorIcon;
  var responsive = useResponsive();
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx;
  if (status === 'exception') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, errorIcon) || /*#__PURE__*/React.createElement(ProgressErrorIcon, {
      className: cx(styles.errorIcon)
    });
  }
  if (percent === 100) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, successIcon) || /*#__PURE__*/React.createElement(ProgressSuccessIcon, {
      className: cx(styles.successIcon)
    });
  }
  return /*#__PURE__*/React.createElement(Progress, {
    percent: responsive.md ? 0 : percent,
    size: 24,
    type: "circle",
    strokeLinecap: "butt",
    showInfo: true,
    strokeWidth: 2,
    format: function format() {
      return "".concat(step);
    }
  });
};
var StepItem = function StepItem(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$subTitle = _ref2.subTitle,
    subTitle = _ref2$subTitle === void 0 ? '' : _ref2$subTitle,
    _ref2$step = _ref2.step,
    step = _ref2$step === void 0 ? 1 : _ref2$step,
    _ref2$status = _ref2.status,
    status = _ref2$status === void 0 ? 'normal' : _ref2$status,
    _ref2$percent = _ref2.percent,
    percent = _ref2$percent === void 0 ? 0 : _ref2$percent,
    _ref2$tip = _ref2.tip,
    tip = _ref2$tip === void 0 ? '' : _ref2$tip,
    _ref2$isLast = _ref2.isLast,
    isLast = _ref2$isLast === void 0 ? false : _ref2$isLast,
    _ref2$available = _ref2.available,
    available = _ref2$available === void 0 ? true : _ref2$available,
    _ref2$successIcon = _ref2.successIcon,
    successIcon = _ref2$successIcon === void 0 ? null : _ref2$successIcon,
    _ref2$errorIcon = _ref2.errorIcon,
    errorIcon = _ref2$errorIcon === void 0 ? null : _ref2$errorIcon,
    strokeColor = _ref2.strokeColor,
    trailColor = _ref2.trailColor,
    strokeErrorColor = _ref2.strokeErrorColor;
  var responsive = useResponsive();
  var _useStyles2 = useStyles(),
    styles = _useStyles2.styles,
    cx = _useStyles2.cx,
    prefixCls = _useStyles2.prefixCls;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressStepItem, prefixCls + '-progress-step-item')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.flex, styles.relative)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.stepIcon, !available && styles.progressIconTextDisabled, percent === 100 && styles.stepIconSuccess, isLast && styles.progressLast)
  }, /*#__PURE__*/React.createElement(StepItemIcon, {
    status: status,
    step: step,
    percent: percent,
    available: available,
    successIcon: successIcon,
    errorIcon: errorIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressText)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx(styles.progressTitle, (percent === 100 || !available) && styles.progressTitleDisabled)
  }, title), /*#__PURE__*/React.createElement("span", {
    className: cx(styles.progressSubTitle)
  }, subTitle), !responsive.md && /*#__PURE__*/React.createElement("span", {
    className: cx(styles.progressTip)
  }, tip))), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressBar, step === 1 && styles.progressBarFirst, isLast && styles.progressBarLast)
  }, responsive.md && /*#__PURE__*/React.createElement(Progress, {
    percent: percent,
    showInfo: false,
    status: status,
    strokeLinecap: "butt",
    strokeWidth: 8,
    strokeColor: strokeColor && strokeErrorColor ? status === 'exception' ? strokeErrorColor : strokeColor : undefined,
    trailColor: trailColor
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressStepNum)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx(styles.stepNumText, !available && styles.stepNumTextDisabled)
  }, "Step ", step), /*#__PURE__*/React.createElement("span", {
    className: cx(styles.progressTip)
  }, tip))));
};
var RichProgress = function RichProgress(_ref3) {
  var stepsData = _ref3.stepsData,
    trailColor = _ref3.trailColor,
    strokeColor = _ref3.strokeColor,
    strokeErrorColor = _ref3.strokeErrorColor,
    successIcon = _ref3.successIcon,
    errorIcon = _ref3.errorIcon;
  var _useStyles3 = useStyles(),
    styles = _useStyles3.styles,
    cx = _useStyles3.cx,
    prefixCls = _useStyles3.prefixCls;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressStepsContainer, prefixCls + '-progress-steps-container')
  }, stepsData.map(function (stepItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: cx(styles.progressSteps, prefixCls + '-progress-steps')
    }, /*#__PURE__*/React.createElement(StepItem, {
      step: index + 1,
      status: stepItem.status,
      title: stepItem.title,
      subTitle: stepItem.subTitle,
      percent: stepItem.percent,
      isLast: index + 1 === stepsData.length,
      available: stepItem.available,
      tip: stepItem.progressTip,
      successIcon: successIcon,
      errorIcon: errorIcon,
      trailColor: trailColor,
      strokeColor: strokeColor,
      strokeErrorColor: strokeErrorColor
    }));
  }));
};
export default /*#__PURE__*/memo(RichProgress);